import { LineChart } from '@mui/x-charts/LineChart';

const LineChartData = ({ linechart, selectedfilter }) => {
  const showData = linechart.data || [];

  const getDataByFilter = (data, filter) => {
    if (!data) return Array.from({ length: filter === "month" ? 12 : 31 }, () => 0);
    return Object.values(data).slice(0, filter === "month" ? 12 : 31);
  };

  const commercialData = getDataByFilter(showData?.CommercialCountByMonth || showData?.CommercialCountByDay, selectedfilter);
  const residentialData = getDataByFilter(showData?.ResidentialCountByMonth || showData?.ResidentialCountByDay, selectedfilter);
  const applicationsData = getDataByFilter(showData?.applicationsSubmittedCountByMonth || showData?.applicationsSubmittedCountByDay, selectedfilter);
  const subsidiesData = getDataByFilter(showData?.subsidiesReceivedCountByMonth || showData?.subsidiesReceivedCountByDay, selectedfilter);
  const dispatchData = getDataByFilter(showData?.dispatchCountByMonth || showData?.dispatchCountByDay, selectedfilter);
  const pendingAccountsData = getDataByFilter(showData?.accountsWithPendingAmountByMonth || showData?.accountsWithPendingAmountByDay, selectedfilter);

  const xLabels = selectedfilter === "month"
    ? ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    : Array.from({ length: 31 }, (_, i) => (i + 1).toString());

  return (
    <LineChart
      height={350}
      series={[
        { data: commercialData, label: 'Commercial', showMark: false },
        { data: residentialData, label: 'Residential', showMark: false },
        { data: applicationsData, label: 'Applications Submitted', showMark: false },
        { data: subsidiesData, label: 'Subsidies Received', showMark: false },
        { data: dispatchData, label: 'Dispatch Count', showMark: false },
        { data: pendingAccountsData, label: 'Pending Accounts', showMark: false },
      ]}
      xAxis={[{
        scaleType: 'point',
        data: xLabels,
        tickLabelStyle: {
          angle: 0,
          textAnchor: 'middle',
          fontSize: 12,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }
      }]}
      slotProps={{
        legend: {
          direction: 'row',
          position: { vertical: 'top', horizontal: 'middle' },
          padding: 0,
          sx: {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            minWidth: '700px',
            maxWidth: '100%',
            whiteSpace: 'nowrap'
          }
        }
      }}
    />
  );
};

export default LineChartData;
